<div class="modal-header">
    <h4 class="modal-title">Elimina Indice</h4>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismiss()"></button>
</div>
<div class="modal-body">
    <div class="text-center">
        <div class="mb-3" style="color: #dc2626;">
            <span class="material-symbols-outlined" style="font-size: 48px;">warning</span>
        </div>
        <p>
            Sei sicuro di voler eliminare l'indice
            <strong>{{ indexItem.name }}</strong>?
        </p>
        <p class="text-muted small">
            Questa azione è irreversibile e rimuoverà tutti i vettori associati.
        </p>
    </div>
</div>
<div class="modal-footer justify-content-center">
    <button type="button" class="btn btn-secondary" (click)="dismiss()">Annulla</button>
    <button type="button" class="btn btn-danger" (click)="confirmDelete()" [disabled]="isDeleting()">
        @if (isDeleting()) { Eliminazione... } @else { Elimina Indice }
    </button>
</div>